<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs4>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>

                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">JDT Attendance Log Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-flex xs12>
                    <v-card
                        class="ma-3 pa-3"
                        elevation="0"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 md2 class="pa-1">
                                <v-menu
                                    ref="calendarMenu"
                                    v-model="calendarMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="startDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="startDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendarMenu = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendarMenu.save(date)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1 hideOnPrint">
                                <v-menu
                                    ref="calendar2Menu"
                                    v-model="calendar2Menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="endDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable

                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="endDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendar2Menu = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendar2Menu.save(date)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 md3 class="pa-1 mb-2 hideOnPrint">
                                <v-select
                                    label="Select a Client"
                                    :items="clients"
                                    item-text="Name"
                                    item-value="_id"
                                    v-model="clientID"
                                    clearable
                                    :required="requiredField"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md5 class="mt-5 mb-5 pl-5">
                                <v-btn
                                    small
                                    @click="getQueryData()"
                                    class="ma-1">
                                Search
                                </v-btn>
                                <v-btn
                                    small
                                    @click="generatePDF()"
                                    class="ma-1"
                                    v-if="canExport">
                                    Generate Billing
                                </v-btn>

                                <v-dialog v-model="dialog" max-width="100%">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="#2b3990" small dark v-on="on" @click="showAdd()">
                                            <v-icon left>add</v-icon>
                                            Add JDT Attendance Log
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title style="background-color: #2b3990">
                                            <span class="headline white--text">{{ titleForm }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-form
                                                ref="form"
                                                lazy-validation
                                            >
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="5" v-if="newCase">
                                                            <v-select
                                                                label="Select Client"
                                                                :items="clients"
                                                                v-model="newClients"
                                                                item-text="Name"
                                                                item-value="_id"
                                                                :rules="requiredField"
                                                                @change="changeClient"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="5" v-if="editCase">
                                                            <v-select
                                                                label="Client"
                                                                :items="clients"
                                                                v-model="newClients"
                                                                item-text="Name"
                                                                item-value="_id"
                                                                :rules="requiredField"
                                                                @change="changeClient"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" md="3">
                                                            <v-text-field
                                                                label="Case #"
                                                                v-model="newCaseNumber"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="4">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="menu"
                                                                :close-on-content-click="false"
                                                                :return-value.sync="date"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        v-model="newDate"
                                                                        label="Log date"
                                                                        prepend-icon="mdi-calendar"
                                                                        readonly
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        :rules="requiredField"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="newDate"
                                                                    no-title
                                                                    scrollable
                                                                >
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        text
                                                                        color="primary"
                                                                        @click="menu = false"
                                                                    >
                                                                        Cancel
                                                                    </v-btn>
                                                                    <v-btn
                                                                        text
                                                                        color="primary"
                                                                        @click="$refs.menu.save(newDate)"
                                                                    >
                                                                        OK
                                                                    </v-btn>
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-select
                                                                :items="providers"
                                                                label="Provider"
                                                                item-text="name"
                                                                item-value="id"
                                                                v-model="newProvider"
                                                                :rules="requiredField"
                                                            ></v-select>
                                                        </v-col>
                                                        

                                                        <v-col cols="12">
                                                            <v-textarea
                                                                label="Address of Home"
                                                                v-model="newAddress"
                                                                :rules="requiredField"
                                                                outlined
                                                                maxlength="75"
                                                                counter
                                                            ></v-textarea>
                                                        </v-col>

                                                        <v-col cols="12">
                                                            <v-text-field
                                                                label="Home Capacity"
                                                                v-model="newHomeCapacity"
                                                                outlined
                                                            ></v-text-field>
                                                        </v-col>

                                                        <v-col cols="12">
                                                            <v-radio-group 
                                                                dense
                                                                row
                                                                label="Type of Home:"
                                                                v-model="newTypeOfHome"
                                                            >
                                                                <v-radio   
                                                                    label="Shared Living"
                                                                    value="Shared Living"
                                                                ></v-radio>
                                                                <v-radio   
                                                                    label="24-Hour Isla"
                                                                    value="24-Hour Isla"
                                                                ></v-radio>
                                                                <v-radio   
                                                                    label="Tier 1"
                                                                    value="Tier 1"
                                                                ></v-radio>
                                                                <v-radio  
                                                                    label="Tier 2"
                                                                    value="Tier 2"
                                                                ></v-radio>
                                                                <v-radio  
                                                                    label="Tier 3"
                                                                    value="Tier 3"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-col>

                                                        <v-col cols="12" sm="12">
                                                            <v-checkbox
                                                                label="Staff Signature"
                                                                v-model="staffSignature"
                                                                @click="addStaffSignature()"
                                                                :rules='requiredField'
                                                            ></v-checkbox>
                                                        </v-col>

                                                        <v-col class="d-flex" cols="12" sm="12">
                                                            <v-text-field 
                                                                v-if="staffSignature"
                                                                v-model="newStaffSignature" 
                                                                label="Signed By" 
                                                                readonly>
                                                            </v-text-field>
                                                        </v-col>

                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                class="white--text"
                                                color="#259647"
                                                @click="addJDTLog()"
                                                v-if="newCase"
                                            >Save
                                            </v-btn
                                            >
                                            <v-btn
                                                class="white--text"
                                                color="#259647"
                                                @click="updateJDTLog()"
                                                v-if="editCase"
                                            >Update
                                            </v-btn
                                            >
                                            <v-btn color="blue darken-1" text @click="close"
                                            >Cancel
                                            </v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>

                <v-flex xs12 class="pa-2 hideOnPrint">
                    <v-data-table
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                        :headers="headers"
                        :items="JdtAttendanceLogs"
                        sort-by="Date"
                        sort-desc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading JDT Attendance Logs"
                        :items-per-page="100"

                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewLog(item)"
                            >
                                view
                            </v-btn>
                        </template>
                    </v-data-table>

                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>
<script>
import axios from 'axios'
import {mapActions} from 'vuex';
import momentTz from 'moment-timezone';
import Swal from "sweetalert2";
import {DateTime} from 'luxon';

const url = require("../../client_config/config").url;

export default {
    components: {},
    data: () => ({
        headers: [
            {
                text: "Date",
                align: "start",
                sortable: false,
                value: "Date",
            },
            {text: "Client", value: "ClientID.Name"},
            {text: "Code", value: "Code"},
            {text: "Actions", value: "actions", sortable: false},
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        startDate: "",
        endDate: "",
        menu: false,
        calendarMenu: false,
        calendar2Menu: false,
        dialog: false,
        reportDialog: false,
        editCase: false,
        newCase: false,
        msg: false,
        search: "",
        text: "",
        JdtAttendanceLogs: [],
        tempData: [],
        clients: [],
        clientID: "",
        titleForm: "New JDT Attendance Log",
        JDTLogID: "",
        newDate: "",
        newTime: "",
        newCode: null,
        newLocation: null,
        newLevel: "",
        newServiceProvided: "",
        staffSignature: false,
        newStaffSignature: "",
        userID: localStorage.getItem('userID'),
        staff: localStorage.getItem('Name'),
        requiredField: [
            v => !!v || 'This is required',
        ],
        isLoading: false,
        isDownloading: false,
        userState: localStorage.getItem('userState'),
        reportItems: ['PDF'],
        newClients: '',
        companyID: localStorage.getItem('userCompanies'),
        page: 1,
        pageCount: 1,
        itemCount: 0,
        options: {},
        newHomeCapacity: '',
        newTypeOfHome: '',
        newAddress: '',
        newProvider: '',
        providers: [],
        newCaseNumber: '',
        apiEndpoint: 'jdtAttendanceLog'
    }),

    computed: {
        canExport() {
            return this.startDate && this.endDate && this.clientID != '' && this.JdtAttendanceLogs.length > 0;
        },
    },

    watch: {
    },

    created() {
        this.getClients();
    },

    methods: {
        ...mapActions({
            downloadCaseManagementReport: "caseManagement/downloadCaseManagementReport",
            getClientProviders: "clientProviders/getItem",
        }),

        async getProviders(){
            let clientId = this.newClients;
            const response = await this.getClientProviders(clientId);
            this.providers = response.data.map((provider) => {

                const {_id, Name} = provider.Provider;
                const obj = {
                    id: _id,
                    name: Name
                }
                return obj;
            });

            this.setProgram(clientId);
        },

        initialize() {
            this.clients = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        updateList() {
            console.log(this.newClients)
        },

        getClients() {
            if (this.userState) {
                return axios.get(`${url}/clients/status/state/nevada/active`).then(async res => {
                    this.clients = res.data.clients;
                });
            }
        },

        clear() {
            this.newDate = "";
            this.newStaffSignature = "";
            this.staffSignature = false;
            this.newClients = '';
            this.newProvider = '';
            this.newHomeCapacity =  '';
            this.newTypeOfHome =  '';
            this.newAddress =  '';
            this.newProvider =  '';
            this.providers =  [];
            this.newCaseNumber = '';
        },


        close() {
            this.clear();
            this.dialog = false;
        },

        async generatePDF() {
            const userConfirmed = window.confirm("By continuing, you acknowledge that you are creating the billing for the month provided and the data can not be edited. Do you want to continue?");
            
            if (userConfirmed) {
                try {
                    // Extract year and month from the startDate and endDate strings
                    const startYear = this.startDate.split('-')[0]; // Extract the year from startDate
                    
                    // Extract year and month from the startDate and endDate strings
                    const startYearMonth = this.startDate.slice(0, 7); // "YYYY-MM"
                    const endYearMonth = this.endDate.slice(0, 7);     // "YYYY-MM"

                    // If the start and end dates are not in the same month, alert the user
                    if (startYearMonth !== endYearMonth) {
                        alert("Start and end dates must be within the same month.");
                        return;
                    }

                    // Get the month name directly from the startDate string without time zone conversion
                    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    const startMonth = parseInt(this.startDate.split('-')[1], 10); // Extract the month as a number
                    const month = monthNames[startMonth - 1];

                    const formData = new FormData();
                    formData.append('Client', this.clientID);
                    formData.append('Month', month);
                    formData.append('Year', startYear);
                    formData.append('StartDate', this.startDate);
                    formData.append('EndDate', this.endDate);
                    formData.append('Report', "JDT AttendanceLog");
                    formData.append('Status', "Incomplete");
                    formData.append('CreatedBy', this.staff + " - " + new Date());

                    // Fetch the PDF from the caseManagement route
                    const response = await axios.get(
                        `${url}/${this.apiEndpoint}/billingPDF`, 
                        {params: {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientID: this.clientID,
                            userID: this.userID,
                            monthYear: startMonth + '/' + startYear
                        }});
                    
                    const pdfFile = response.data.data; // Base64 PDF data

                    // Convert Base64 PDF to a Blob
                    const byteCharacters = atob(pdfFile);
                    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    formData.append('document', blob, "DS-SLA-01_RSM_Log_v.2.2024_Form.pdf");

                    // Send formData to the backend
                    await axios.post(`${url}/billings/saveBilling`, formData, {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    });

                    this.msg = true;
                    this.text = "Billing saved successfully. Go to billing report to view."

                    console.log("Billing data saved successfully.");

                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        alert(error.response.data.message); // Display the duplicate billing error message
                    } else {
                        console.log("Error during PDF generation or data saving:", error);
                    }
                }
            } else {
                console.log("User canceled the PDF generation.");
            }
        },

        getQueryData() {
            this.JdtAttendanceLogs = []
            this.isLoading = true

            let {page, itemsPerPage} = this.options;
            page = page || 1;
            itemsPerPage = itemsPerPage || 100;


            this.startDate = this.startDate || '';
            this.endDate = this.endDate || '';
            this.ClientID = this.ClientID || '';

            const params = {
                page: page,
                limit: itemsPerPage,
                startDate: this.startDate,
                endDate: this.endDate,
                clientID: this.clientID
            }

            axios.get(`${url}/${this.apiEndpoint}/reports`, {params})
                .then(response => {
                    const {docs, totalPages, totalDocs} = response.data;

                    this.JdtAttendanceLogs = docs.map((doc) => {
                        doc.Date = this.formatDate(doc.Date);
                        return doc;
                    });

                    this.pageCount = totalPages;
                    this.itemCount = totalDocs;

                }).finally(() => {
                this.isLoading = false;
            })

        },

        async downloadCaseManagementPDF() {
            this.isDownloading = true
            const startDate = new Date(`${this.startDate}`).toISOString()
            const endDate = new Date(`${this.endDate}`).toISOString()
            const tz = momentTz.tz.guess();

            const data = {
                startDate,
                endDate,
                clientId: this.clientID,
                tz
            }
            try {
                const response = await this.downloadCaseManagementReport(data)
                if (response.status === 400) {
                    this.isDownloading = false
                    return alert('Unable to download report')
                }
                const blob = new Blob([response.data], {type: 'application/pdf'})
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'case-management-report.pdf')
                document.body.appendChild(link)
                link.click()
                this.isDownloading = false
            } catch (error) {
                this.isDownloading = false
                console.log(error)
            }
        },

        download() {
            if (this.startDate == '' || this.startDate == null
                && this.endDate == '' || this.endDate == null) {
                this.msg = true;
                this.text = "Please add start date and end date to download report"
            } else if (this.endDate == '' || this.endDate == null) {
                this.msg = true;
                this.text = "Please add an end date to download report"

            } else {
                this.downloadCaseManagementPDF()
            }
        },

        print() {
            Swal.fire({
                title: "Print in Progress",
                text: "Please wait while the PDF is being generated and processed. This may take a while if some images or files are attached.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            fetch(`${url}/caseManagement/generate/pdf/${this.startDate}/${this.endDate}/${this.clientID}`)
                .then((response) => response.blob())
                .then((blob) => {
                    const blobUrl = URL.createObjectURL(blob);
                    const printWindow = window.open(blobUrl);

                    printWindow.onload = function () {
                        Swal.close();
                        printWindow.print();
                        URL.revokeObjectURL(blobUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating or printing the PDF:", error);
                    Swal.fire("Error", "Failed to generate or print the PDF", "error");
                });
        },

        updateJDTLog() {
            
            let req_body = {
                Date: this.newDate,
                Code: this.newCaseNumber,
                Provider: this.newProvider,
                Address: this.newAddress,
                HomeCapacity: this.newHomeCapacity,
                TypeOfHome: this.newTypeOfHome,
                StaffSignature: this.newStaffSignature,
                ClientID: this.newClients,  // Use _id from client
            };
            
            let updateIndex = this.JdtAttendanceLogs.findIndex((log) => this.JDTLogID == log._id);
            axios
                .put(`${url}/${this.apiEndpoint}/${this.JDTLogID}`, req_body)
                .then((response) => {
                    if (response.status >= 400) {
                        response.json().then(function (data) {
                            alert(data.msg);
                        });
                    } else {
                        let allLogs = this.JdtAttendanceLogs;
                        const updatedRecord = {...response.data.data};
                        updatedRecord.Date = this.formatDate(updatedRecord.Date);

                        allLogs[updateIndex] = updatedRecord;
                        this.JdtAttendanceLogs = [...allLogs];
                    }
                    this.clear();
                    this.msg = true;
                    this.text = "The record has been updated successfully.";
                });
            
            this.close();
        },

        getClientID(item) {
            this.client = item.ClientID._id;
        },

        viewLog(item) {
            console.log(item);
            this.titleForm = "Viewing JDT Attendance Log"
            this.dialog = true;
            this.editCase = true;
            this.newCase = false;
            this.newAddress = item.Address;
            this.newCaseNumber = item.Code;
            this.newDate = item.Date;
            this.newHomeCapacity = item.HomeCapacity;
            this.newTypeOfHome = item.TypeOfHome;
            this.newProvider = item.Provider;

            if(item.StaffSignature){
                this.newStaffSignature = item.StaffSignature;
                this.staffSignature = true
            }
            this.newClients = item.ClientID._id;
            this.JDTLogID = item._id;
            this.getProviders();
        },

        showAdd() {
            this.titleForm = "JDT Attendance Log";
            this.newCase = true;
            this.editCase = false;
        },

        addJDTLog: function () {
            if (this.validate()) {
                // Assuming newClients is an array of clients
                let req_body = {
                    Date: this.newDate,
                    Code: this.newCaseNumber,
                    Provider: this.newProvider,
                    Address: this.newAddress,
                    HomeCapacity: this.newHomeCapacity,
                    TypeOfHome: this.newTypeOfHome,
                    StaffSignature: this.newStaffSignature,
                    ClientID: this.newClients,  // Use _id from client
                };

                axios.post(`${url}/${this.apiEndpoint}`, req_body).
                    then(response => {
                        console.log(response);
                        this.getQueryData();
                    })
            } else {
                this.msg = true;
                this.text = "Please fill out all required fields";
            }
        },
        addStaffSignature() {
            if (!this.newStaffSignature) {
                this.staffSignature = true;
                this.newStaffSignature = this.staff + " - " + new Date();
            } else {
                this.newStaffSignature = ""
                this.staffSignature = false;
            }

        },
        printTable() {

            window.print()

        },

        printItem() {
            document.getElementById('printTable').style.display = "none";

            window.print()
        },
        setProgram(clientId) {
            const client = this.clients.find(client => client._id === clientId);

            if (client && client.Program && client.Program.length) {
                this.selectedClientPrograms = client.Program;
                this.newProgram = client.Program[0];
            }
        },

        changeClient() {
            this.getProviders();
            this.newCaseNumber = this.clients.find(client => client._id == this.newClients)?.Case;
        },

        formatDate(date) {
            const format = DateTime.fromISO(date);
            return format.toISODate();
        }
    }
}
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1300px;
        padding-right: 300px;
        margin-left: -200px;

    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>